/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '~/store';

export type StatePayload<T = any> = {
  key: string;
  data: T;
};
export type StateCallbackPayload<T = any> = {
  key: string;
  callback: (prev: T) => T;
};
const initialState: Record<string, any> = {
  isItMoreThanOneService: false,
  editCardholderModal: false,
  nodeDetails: null,
  editedNodeDetails: null,
  deleteNode: false,
  hierarchylevels: ['company', 'cardholder'],
};

const slice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    setStateAction: (state, action: PayloadAction<StatePayload>) => {
      state[action.payload.key] = action.payload.data;
    },
    setStateWithCallbackAction: (state, action: PayloadAction<StateCallbackPayload>) => {
      const prevState = state[action.payload.key];
      let prev = null as any;
      if (Array.isArray(prevState)) {
        prev = [...prevState];
      } else {
        prev = { ...(state[action.payload.key] || {}) };
      }
      state[action.payload.key] = action.payload.callback(prev);
    },
    setStackInitialStateAction: (state, action: PayloadAction<StatePayload>) => {
      state[action.payload.key] = action.payload.data;
    },
    setIsItMoreThanOneService: (state, action: any) => {
      state.isItMoreThanOneService = action.payload;
    },
    setOpencarholdereditModal: (state, action: any) => {
      state.editCardholderModal = action.payload;
    },
    setNodeDetails: (state, action: any) => {
      state.nodeDetails = action.payload;
    },
    setEditedNodeDetails: (state, action: any) => {
      state.editedNodeDetails = action.payload;
    },
    setDeleteNode: (state, action: any) => {
      state.deleteNode = action.payload;
    },
    setHierarchylevels: (state, action: any) => {
      state.hierarchylevels = action.payload;
    },
    setShowStatusAlert: (state, action: any) => {
      state.showStatusAlert = action.payload;
    },
    setLeafNodesHaveNocardholders: (state, action: any) => {
      state.leafNodesHaveNocardholders = action.payload;
    },
    setEditLeafeNodes: (state, action: any) => {
      const { productKey, newproductLeafList } = action.payload;
      state.leafNodesHaveNocardholders[productKey] = newproductLeafList;
    },
    setConfirmValue: (state: any, action: any) => {
      state.confirmValue = action.payload;
    },
    setShowProductSelection: (state: any, action: any) => {
      state.showProductSelection = action.payload;
    },
    setEnabledServices: (state, action: any) => {
      state.enabledServices = action.payload;
    },
    setPanelValueErr: (state, action: any) => {
      const { keys, sectionName } = action.payload;
      state.panelError = {
        [sectionName]: keys,
      };
    },
    setApplicationStage: (state, action: any) => {
      state.applicationStage = action.payload;
    },
    setShareholdersErrors: (state, action: any) => {
      state.applicationStage = action.payload;
    },
    setHierarchyErr: (state, action: any) => {
      state.hierarchyErr = action.payload;
    },
    setCallHieDraft: (state: any) => {
      state.callHieDraft = !state.callHieDraft;
    },
    setCardholderData: (state: any, action: any) => {
      state.cardholderData = action.payload;
    },
    setAddingExistingUserValues: (state: any, action?: any) => {
      state.selectedContact = action?.payload;
    },
    setIsCopyingBtnPressed: (state: any, action: any) => {
      state.isCopyingBtnPressed = action?.payload;
    },
  },
});

export const {
  setStateAction,
  setStackInitialStateAction,
  setStateWithCallbackAction,
  setIsItMoreThanOneService,
  setOpencarholdereditModal,
  setNodeDetails,
  setEditedNodeDetails,
  setDeleteNode,
  setHierarchylevels,
  setShowStatusAlert,
  setLeafNodesHaveNocardholders,
  setConfirmValue,
  setEditLeafeNodes,
  setPanelValueErr,
  setEnabledServices,
  setApplicationStage,
  setShareholdersErrors,
  setHierarchyErr,
  setCallHieDraft,
  setShowProductSelection,
  setCardholderData,
  setAddingExistingUserValues,
  setIsCopyingBtnPressed,
} = slice.actions;

export const getState =
  <T = any>(key: string) =>
  (rootState: RootState): T =>
    rootState.state[key];
export default slice.reducer;
